import React, { useState } from "react";
import { toast } from "react-toastify";
import apiServices from "../../services/service";
import FormModalWrapper from "../../shared/modal/FormModalWrapper";
import SearchableDropDown from "../../shared/controls/form/searchableDropdown";

const AddTeamForm = ({ open, onClose, onSave, usersList = [] }) => {
  const [teamName, setTeamName] = useState("");
  const [teamOwner, setTeamOwner] = useState(null);
  const [teamCaptain, setTeamCaptain] = useState(null);
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);

  const userOptions = usersList.map((u) => ({
    value: u.userId,
    label:
      `${u.firstName || ""} ${u.lastName || ""}`.trim() ||
      u.userName ||
      u.emailAddress ||
      u.email ||
      "",
  }));

  const reset = () => {
    setTeamName("");
    setTeamOwner(null);
    setTeamCaptain(null);
    setErrors({});
  };

  const handleClose = () => {
    reset();
    onClose();
  };

  const handleSave = () => {
    const newErrors = {};
    if (!teamName.trim()) newErrors.teamName = "Team name is required";
    if (!teamOwner) newErrors.teamOwner = "Team owner is required";
    if (!teamCaptain) newErrors.teamCaptain = "Team captain is required";
    if (Object.keys(newErrors).length) {
      setErrors(newErrors);
      return;
    }

    const payload = {
      teamName: teamName.trim(),
      teamOwnerId: teamOwner?.value ?? null,
      teamCaptainId: teamCaptain?.value ?? null,
    };

    setSaving(true);
    apiServices
      .addTeams(payload)
      .then((response) => {
        toast.success("Team added successfully!", { position: "top-right" });
        onSave(response.data);
        reset();
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || error.message || "Failed to add team", {
          position: "top-right",
        });
      })
      .finally(() => setSaving(false));
  };

  return (
    <FormModalWrapper
      open={open}
      onClose={handleClose}
      breadcrumb="Team Management"
      title="Add Team"
      size="sm"
      onSave={handleSave}
      saveDisabled={saving}
    >
      <div className="row">
        <div className="col-12">
          <div className="input-container">
            <label htmlFor="teamName">
              Team Name <span className="required-star">*</span>
            </label>
            <input
              id="teamName"
              className="formik-input"
              type="text"
              value={teamName}
              onChange={(e) => {
                setTeamName(e.target.value);
                if (errors.teamName) setErrors((prev) => ({ ...prev, teamName: undefined }));
              }}
              placeholder="Enter team name"
            />
            {errors.teamName && (
              <div className="error-message">{errors.teamName}</div>
            )}
          </div>
        </div>

        <div className="col-12">
          <div className="input-container">
            <SearchableDropDown
              label="Team Owner"
              name="teamOwner"
              fieldName="teamOwner"
              value={teamOwner}
              placeholder="Select team owner"
              options={userOptions}
              isRequired
              error={!!errors.teamOwner}
              errormsg={errors.teamOwner}
              onChange={(selected) => {
                setTeamOwner(selected);
                if (errors.teamOwner) setErrors((prev) => ({ ...prev, teamOwner: undefined }));
              }}
            />
          </div>
        </div>

        <div className="col-12">
          <div className="input-container">
            <SearchableDropDown
              label="Team Captain"
              name="teamCaptain"
              fieldName="teamCaptain"
              value={teamCaptain}
              placeholder="Select team captain"
              options={userOptions}
              isRequired
              error={!!errors.teamCaptain}
              errormsg={errors.teamCaptain}
              onChange={(selected) => {
                setTeamCaptain(selected);
                if (errors.teamCaptain) setErrors((prev) => ({ ...prev, teamCaptain: undefined }));
              }}
            />
          </div>
        </div>
      </div>
    </FormModalWrapper>
  );
};

export default AddTeamForm;
